import { render } from "./BrowseCategories.vue?vue&type=template&id=0c66a92c&scoped=true&ts=true"
import script from "./BrowseCategories.ts?vue&type=script&lang=ts"
export * from "./BrowseCategories.ts?vue&type=script&lang=ts"

import "./BrowseCategories.vue?vue&type=style&index=0&id=0c66a92c&scoped=true&lang=scss"

import exportComponent from "D:\\ColorMetalBG\\cmportal-frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c66a92c"]])

export default __exports__